import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TableUtil } from '../tableUtil';
import { ExcelService } from '../service/tableUtility.service';
import { userManagement } from '../models/userManagement';

@Component({
  selector: 'app-usermanagment',
  templateUrl: './usermanagment.component.html',
  styleUrls: ['./usermanagment.component.css']
})
export class UsermanagmentComponent implements OnInit {

  userAddObj:userManagement
  showFilter:boolean=false
  tableData: [] = [];
  userDetails:any;
  userSessionData:any
  read:any;
  write:any;
  delete:any;
  export:any
  show:boolean=false
  dataSource:any;
  searchValue:any;
  filterValueSelected:any;
  showCustomisedSearch:boolean=false
  displayedColumns = ['_id','mobileNumber','mobileStatus','status','dateOfCreation','Action'
   ]
  @ViewChild(MatSort,{static:true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;  
  constructor(private cs:CucurachaAdminService,private toastr: ToastrManager, private excelService: ExcelService) {
    this.userAddObj=new userManagement()
   } 
   filter() {
    this.getAllUsers()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllUsers();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForUsers(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllUsers()
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getAllUsers(){
    this.cs.getAllUsers().subscribe((data) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }
  deleteuser(id:any){
    this.cs.deleteuser(id).subscribe((data) => {
      this.getAllUsers();
      this.toastr.warningToastr("Data  Deleted");

    })
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'Users');
    this.cs.exportLogAdd(this.userDetails.emailId, 'Users').subscribe((data) => {
    })
  }
  onChange(status, id) {
    console.log(status.checked)
    this.cs.getByUserId(id).subscribe((data) => {
      this.userAddObj._id = data[0]._id;
      this.userAddObj.status = status.checked;

      this.cs.updateUserStatus(this.userAddObj).subscribe((data) => {
        if(data.result ){
          this.ngOnInit()
          this.toastr.successToastr(data.message);
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
          this.ngOnInit()
    
         }
          else{
            this.toastr.errorToastr(data.message);
            this.ngOnInit()

    
          }
      })
    })
  }
  ngOnInit(): void {
    this.getAllUsers();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].user_management.permissions[0].read);
      this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].user_management.permissions[0].write)
      this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].user_management.permissions[0].delete)
      this.export=(this.userDetails.roledetails[0].components[0].component_name[0][0].user_management.permissions[0].export)
    })
  }

}
